import { useState } from 'react';
import { apiFetch } from '../../../utils/api';

/**
 * Custom hook for managing AdminDashboard API data fetching
 * 
 * @returns {Object} Object containing users, organizations, loading states, and fetch functions
 */
export const useAdminApi = () => {
    const [users, setUsers] = useState([]);
    const [organizations, setOrganizations] = useState([]);
    const [accessRequests, setAccessRequests] = useState([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(true);
    const [isLoadingOrganizations, setIsLoadingOrganizations] = useState(true);

    const fetchUsers = async () => {
        setIsLoadingUsers(true);
        try {
            const res = await apiFetch('/api/auth/admin/users');
            if (res.ok) {
                const data = await res.json();
                setUsers(data);
            }
        } catch (err) {
            console.error('Failed to fetch admin users', err);
        } finally {
            setIsLoadingUsers(false);
        }
    };

    const fetchAccessRequests = async () => {
        try {
            const res = await apiFetch('/api/auth/admin/access-requests');
            if (res.ok) setAccessRequests(await res.json());
        } catch (err) {
            console.error('Failed to fetch access requests', err);
        }
    };

    const fetchOrganizations = async () => {
        setIsLoadingOrganizations(true);
        try {
            const res = await apiFetch('/api/auth/admin/organizations');
            if (res.ok) {
                const data = await res.json();
                setOrganizations(data);
            }
        } catch (err) {
            console.error('Failed to fetch admin organizations', err);
        } finally {
            setIsLoadingOrganizations(false);
        }
    };

    return {
        users,
        setUsers,
        organizations,
        setOrganizations,
        accessRequests,
        isLoadingUsers,
        isLoadingOrganizations,
        fetchUsers,
        fetchOrganizations,
        fetchAccessRequests
    };
};
